import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/axios";
import { Button, Card, Form } from "react-bootstrap";
import "./Attendance.css";
import ShiftForm from "./ShiftForm";
import ShiftList from "./ShiftList";



const Attendance = () => {
  const navigate = useNavigate();
  const [employeeId, setEmployeeId] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [attendanceId, setAttendanceId] = useState(null);

  const [shiftId, setShiftId] = useState("");
  const [shifts, setShifts] = useState([]);

  const [timer, setTimer] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  const [onBreak, setOnBreak] = useState(false);

  const token = localStorage.getItem("access_token");

  const axiosConfig = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // 🔁 Load Shifts
  useEffect(() => {
    axios
      .get(`shifts/`, axiosConfig)
      .then((res) => setShifts(res.data))
      .catch(() => console.error("Failed to load shifts"));
  }, []);

  // ⏱ Timer Logic
  useEffect(() => {
    let interval = null;
    if (isRunning) {
      interval = setInterval(() => {
        setTimer((prev) => prev + 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [isRunning]);

  const formatTime = (seconds) => {
    const h = String(Math.floor(seconds / 3600)).padStart(2, "0");
    const m = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${h}:${m}:${s}`;
  };

  // 🟢 TIME IN
  const handleTimeIn = async () => {
    try {
      const res = await axios.post(
        `attendance/time-in`,
        {
          employee_id: employeeId,
          employee_name: employeeName,
          shift_id: shiftId,
          attendance_date: new Date().toISOString().split("T")[0],
        },
        axiosConfig
      );

      setAttendanceId(res.data.id);
      setIsRunning(true);
      setTimer(0);
      alert("✅ Time In recorded");
    } catch (err) {
      alert("❌ Time In failed");
    }
  };

  // 🔴 TIME OUT
  const handleTimeOut = async () => {
    try {
      await axios.post(
        `attendance/time-out`,
        { attendance_id: attendanceId },
        axiosConfig
      );

      setIsRunning(false);
      setOnBreak(false);
      alert("✅ Time Out recorded");
    } catch (err) {
      alert("❌ Time Out failed");
    }
  };

  // ☕ BREAK IN
  const handleBreakIn = async () => {
    try {
      await axios.post(
        `attendance/break-in`,
        { attendance_id: attendanceId },
        axiosConfig
      );

      setIsRunning(false);
      setOnBreak(true);
    } catch {
      alert("❌ Break In failed");
    }
  };

  // ☕ BREAK OUT
  const handleBreakOut = async () => {
    try {
      await axios.post(
        `attendance/break-out`,
        { attendance_id: attendanceId },
        axiosConfig
      );

      setIsRunning(true);
      setOnBreak(false);
    } catch {
      alert("❌ Break Out failed");
    }
  };

  return (
    <>
      <Card className="p-4 shadow-sm mb-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h4 className="mb-0">🕒 Employee Attendance</h4>
          <Button variant="secondary" onClick={() => navigate("/dashboard")}>
            Back to Dashboard
          </Button>
        </div>

        <Form>
          <Form.Group className="mb-2">
            <Form.Label>Employee ID</Form.Label>
            <Form.Control
              value={employeeId}
              onChange={(e) => setEmployeeId(e.target.value)}
              disabled={attendanceId !== null}
            />
          </Form.Group>

          <Form.Group className="mb-2">
            <Form.Label>Employee Name</Form.Label>
            <Form.Control
              value={employeeName}
              onChange={(e) => setEmployeeName(e.target.value)}
              disabled={attendanceId !== null}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Shift</Form.Label>
            <Form.Select
              value={shiftId}
              onChange={(e) => setShiftId(e.target.value)}
              disabled={attendanceId !== null}
            >
              <option value="">Select Shift</option>
              {shifts.map((s) => (
                <option key={s.id} value={s.id}>
                  {s.name}
                  {s.is_flexible ? " (Flexible)" : ""}
                  {s.is_double ? " (Double)" : ""}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <h5 className="mb-3">⏱ {formatTime(timer)}</h5>

          <div className="d-flex gap-2 flex-wrap">
            <Button
              className="time-in-btn"
              onClick={handleTimeIn}
              disabled={!employeeId || !employeeName || !shiftId || attendanceId}
            >
              Time In
            </Button>

            <Button
              className="break-in-btn"
              onClick={handleBreakIn}
              disabled={!attendanceId || onBreak}
            >
              Break In
            </Button>

            <Button
              className="break-out-btn"
              onClick={handleBreakOut}
              disabled={!attendanceId || !onBreak}
            >
              Break Out
            </Button>

            <Button
              className="time-out-btn"
              onClick={handleTimeOut}
              disabled={!attendanceId}
            >
              Time Out
            </Button>
          </div>
        </Form>
      </Card>

      {/* Shift Management */}
      <ShiftForm />
      <ShiftList />
    </>
  );
};

export default Attendance;
